export const VIDEO_LISTS = {
    'forbes-glavnoe': '/tegi/forbes-glavnoe',
    'forbes-interview': '/tegi/forbes-talk',
    'forbes-notforbes': '/tegi/neforbsy',
    'forbes-biznes-klass': '/tegi/forbes-biznes-klass',
    'forbes-capital': '/tegi/forbes-capital-0',
};
